
import {lockScroll, unlockScroll} from '~/utils/lock-scroll';

export default {
  name: 'base-bottom-bar',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isOpen: {
      handler(value) {
        if (value) lockScroll();
        else {
          setTimeout(() => {
            unlockScroll();
          }, 320);
        }
      },
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
